import { render } from "./ChipComponent.vue?vue&type=template&id=e4743fe4&scoped=true"
import script from "./ChipComponent.vue?vue&type=script&lang=js"
export * from "./ChipComponent.vue?vue&type=script&lang=js"

import "./ChipComponent.vue?vue&type=style&index=0&id=e4743fe4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4743fe4"]])

export default __exports__